module.exports = __webpack_public_path__ + "statics/img/user-img.7e03532d.png";